// extracted by mini-css-extract-plugin
export default {"dataTableFormat":"Filtro_styles_dataTableFormat__5uLao","formSpace":"Filtro_styles_formSpace__yggaX"};